import React from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Form, Row } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

import { useAppState } from '../AppContext';

const SearchForm = ({ searchFulltext, searchString }) => {
  const inputRef = React.createRef();

  const [{documents, clusterData}] = useAppState();
  const searchEnabled = documents && clusterData;

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        searchFulltext(inputRef.current.value);
      }}
      id="search-form"
    >
      <Form.Group as={Row} controlId="search">
        <Col style={{ margin: 'auto', width: '75%', float: 'left' }}>
          <Form.Control ref={inputRef} defaultValue={searchString} disabled={!searchEnabled} />
        </Col>
        <Col sm="4">
          <Button onClick={(ev) => searchFulltext(inputRef.current.value)} disabled={!searchEnabled}>
            <FaSearch />
          </Button>
        </Col>
      </Form.Group>
    </Form>
  );
};

SearchForm.propTypes = {
  searchFulltext: PropTypes.func,
  searchString: PropTypes.string
};

export default SearchForm;
